module.exports = __webpack_public_path__ + "static/img/ligo_08.6cc4f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/jobScreenShot/ligo_08.png
// module id = 3OnI
// module chunks = 0